import React, { Component, Fragment } from 'react';

import classNames from 'classnames';
import { Button } from 'components/cosmos';
import { Input } from 'components/input';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class InputEmbedMedia extends Component {
  static propTypes = {
    mediaurl: PropTypes.string,
    checkEmbedUrl: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    beforeSend: PropTypes.func
  };

  constructor(props) {
    super();

    this.state = {
      inputValue: props.mediaurl
    };
  }

  setMediaValue = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  updateItem = () => {
    const { beforeSend, checkEmbedUrl } = this.props;
    const { inputValue } = this.state;

    beforeSend
      ? beforeSend(checkEmbedUrl, inputValue)
      : checkEmbedUrl(inputValue);
  };

  render() {
    const { children, className } = this.props;
    const { inputValue } = this.state;
    const classComponent = classNames('media__url__wrapper', className);

    return (
      <Fragment>
        <div className={classComponent}>
          <div className="embed__link">
            <Input
              value={inputValue}
              onChange={this.setMediaValue}
              type="text"
              name="media__url"
              className="media__url"
              placeholder="embed.link.placeholder"
            />
            <label className="media__url__label">
              <I18n label="embed.link.label" />
            </label>
          </div>
          <div className="embed__button">
            <Button onClick={this.updateItem} variation="secondary">
              <I18n label="embed.add" />
            </Button>
          </div>
        </div>
        {children}
      </Fragment>
    );
  }
}
